module.exports = __webpack_public_path__ + "static/media/Cell_Gene_Therapy.8084c8f3.svg";